import { render, staticRenderFns } from "./DadataAddressSuggestionsInput.vue?vue&type=template&id=7edfaf68&"
import script from "./DadataAddressSuggestionsInput.vue?vue&type=script&lang=js&"
export * from "./DadataAddressSuggestionsInput.vue?vue&type=script&lang=js&"
import style0 from "./DadataAddressSuggestionsInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports